export const CATEGORIES_OPTIONS = [
  "Hedge Fund",
  "Private Equity",
  "Private Credit",
  "Venture Capital",
  "Real Estate",
  "SMA (Separately Managed Account)",
  "Fund of Funds",
  "Co-Investment",
  "Direct Lending",
  "Infrastructure",
  "Secondaries",
  "SPAC / Blank Check",
  "Managed Futures / CTA",
  "Natural Resources",
];

export const TAGS_OPTIONS = [
  "Fundamental Long/Short",
  "Quantitative / Systematic",
  "Trend Following",
  "Mean Reversion",
  "Statistical Arbitrage",
  "Event Driven",
  "Merger Arbitrage",
  "Distressed / Special Situations",
  "Macro / Global Macro",
  "Relative Value",
  "Volatility Arbitrage",
  "Multi-Strategy",
  "Activist",
  "Credit Long/Short",
  "Convertible Arbitrage",
  "Fixed Income Arbitrage",
  "Sector Specialist",
  "Momentum",
  "Factor-Based",
  "Machine Learning / AI",
  "Leveraged Buyout (LBO)",
  "Growth Equity",
  "Carve-Out / Spin-Off",
  "Turnaround / Operational",
  "Control Equity",
  "Minority Equity",
  "PIPE (Private Investment in Public Equity)",
  "Roll-Up",
  "Management Buyout (MBO)",
  "Pre-Seed / Angel",
  "Seed Stage",
  "Early Stage (Series A/B)",
  "Growth Stage (Series C+)",
  "Late Stage / Pre-IPO",
  "Deep Tech",
  "Impact / ESG Venture",
  "Senior Secured Lending",
  "Unitranche",
  "Mezzanine / Subordinated",
  "Asset-Based Lending (ABL)",
  "Revenue-Based Financing",
  "Venture Debt",
  "Distressed Debt",
  "Opportunistic Credit",
  "Specialty Finance",
  "Structured Credit",
  "CLO / Securitized",
  "Core",
  "Core-Plus",
  "Value-Add",
  "Opportunistic",
  "Development / Ground-Up",
  "REIT Strategy",
  "Real Estate Debt",
  "Core Infrastructure",
  "Greenfield Development",
  "Brownfield / Operational",
  "Digital Infrastructure",
  "Mega / Large Cap (>$1B EV)",
  "Upper Middle Market ($500M–$1B EV)",
  "Core Middle Market ($100M–$500M EV)",
  "Lower Middle Market ($25M–$100M EV)",
  "Small / Micro Buyout (<$25M EV)",
  "Public Mega Cap (>$200B)",
  "Public Large Cap ($10B–$200B)",
  "Public Mid Cap ($2B–$10B)",
  "Public Small Cap ($300M–$2B)",
  "Public Micro Cap (<$300M)",
  "All Cap",
  "Multifamily / Residential",
  "Office",
  "Industrial / Logistics",
  "Retail",
  "Hospitality",
  "Data Centers",
  "Life Sciences / Lab",
  "Self-Storage",
  "Mixed-Use",
  "Single-Family Rental (SFR)",
  "Student / Senior Housing",
  "Energy / Power",
  "Transportation",
  "Telecom / Digital",
  "Water / Utilities",
  "Social Infrastructure",
  "Equities",
  "Fixed Income",
  "Commodities",
  "FX / Currencies",
  "Options / Derivatives",
  "Convertibles",
  "Rates",
  "Crypto / Digital Assets",
  "Real Assets",
  "Multi-Asset",
  "Private Equity Interests",
  "Private Credit / Loans",
  "Real Estate (Direct)",
  "Real Estate (Indirect / REIT)",
  "Infrastructure Assets",
  "Royalties / Streams",
  "Trade Finance",
  "Insurance-Linked Securities",
  "US",
  "North America",
  "Europe",
  "UK",
  "DACH (Germany/Austria/Switzerland)",
  "Nordics",
  "Asia-Pacific",
  "Japan",
  "China",
  "India",
  "Southeast Asia",
  "Emerging Markets",
  "Latin America",
  "Middle East / Africa",
  "Global",
  "Frontier Markets",
  "Israel",
  "Australia / New Zealand",
  "Long Only",
  "Long Bias",
  "Long Lean",
  "Market Neutral",
  "Variable / Flexible",
  "Short Lean",
  "Short Bias",
  "Short Only",
  "N/A (Illiquid / Private)",
  "Intraday / HFT",
  "Short-Term (Days–Weeks)",
  "Medium-Term (Weeks–Months)",
  "Long-Term (1–3 Years)",
  "Multi-Horizon",
  "PE Hold Period (3–5 Years)",
  "PE Hold Period (5–7 Years)",
  "VC Lifecycle (7–10 Years)",
  "Permanent Capital / Evergreen",
  "Real Estate Hold (5–10 Years)",
  "Infrastructure (10+ Years)",
  "Daily Liquid",
  "Weekly Liquid",
  "Monthly Liquid",
  "Quarterly Liquid",
  "Semi-Annual Redemption",
  "Annual Redemption",
  "Soft Lock (1–2 Years)",
  "Hard Lock (2–3 Years)",
  "Illiquid / Full Fund Life",
  "Evergreen (Periodic Windows)",
  "Drawdown / Capital Call",
  "Tender Offer / Interval",
];
